export const columnData = {
  Date: { name: 'Fecha y Hora', widthCol: '25%' },
  UserName: { name: 'Usuario', widthCol: '30%' },
  Description: { name: 'Descripción', widthCol: '50%' },
  Entity: { name: 'Entidad', widthCol: '30%' },
  EntityId: { name: 'Id Entidad', widthCol: '10%' },
  History: { name: 'Historial', widthCol: '15%' }
}
